export default {
  title: `عفوًا!
          <br /> هناك شيء غير صحيح`,
  description: `<p>حدث خطأ ما.</p>
                <p>
                  يرجى المحاولة مرة أخرى لاحقًا. إذا استمرت المشكلة، يرجى الاتصال بفريق الدعم لدينا للحصول على المساعدة.
                </p>`,
};
